module.exports = __webpack_public_path__ + "staticcomp/img/content_4.156d708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/content_4.png
// module id = OdUD
// module chunks = 39